export default __webpack_public_path__ + "static/media/СХОГ_ын_дарга.8eeeb788.pptx";